var map = {
	"./Coin": 34921,
	"./Coin.js": 34921,
	"./Facebook": 29198,
	"./Facebook.js": 29198,
	"./Google": 59827,
	"./Google.js": 59827,
	"./Trophy": 79626,
	"./Trophy.js": 79626,
	"./Whatsapp": 80624,
	"./Whatsapp.js": 80624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97212;